import { FASHION_INSPIRATION_API } from '../constants/api';
import {  GET_PROXY } from '../functions/superagentSending';

const initialState = {
    loading: true,
    data: {
        magazine_url: '',
    },
    error: '',
};

const FETCH_FASHION_INSPIRATION_REQUEST = 'FETCH_FASHION_INSPIRATION_REQUEST';
const FETCH_FASHION_INSPIRATION_SUCCESS = 'FETCH_FASHION_INSPIRATION_SUCCESS';
const FETCH_FASHION_INSPIRATION_FAILURE = 'FETCH_FASHION_INSPIRATION_FAILURE';

const fetchFashionInspirationRequest = () => ({
    type: FETCH_FASHION_INSPIRATION_REQUEST,
});

const fetchFashionInspirationSuccess = (data) => ({
    type: FETCH_FASHION_INSPIRATION_SUCCESS,
    payload: data,
});

const fetchFashionInspirationFailure = (error) => ({
    type: FETCH_FASHION_INSPIRATION_FAILURE,
    payload: error,
});

const FashionInspirationReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_FASHION_INSPIRATION_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_FASHION_INSPIRATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload,
                error: '',
            };
        case FETCH_FASHION_INSPIRATION_FAILURE:
            return {
                loading: false,
                data: {},
                error: payload,
            };
        default:
            return state;
    }
};

export const FETCH_FASHION_INSPIRATION_REDUCER = () => {
    return (dispatch) => {
        dispatch(fetchFashionInspirationRequest());
        GET_PROXY(FASHION_INSPIRATION_API,
            (success) => {
                dispatch(fetchFashionInspirationSuccess(success?.data));
            },
            (error) => {
                dispatch(fetchFashionInspirationFailure(error));
                dispatch(fetchFashionInspirationFailure(''));
            })
    };
};

export default FashionInspirationReducer;
